import React, { useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { fetchCustomerConversationsStart } from './../redux/Conversations/conversations.actions';
import { useDispatch, useSelector } from 'react-redux';
import DashAuthWrapper from './../components/DashAuthWrapper'
// import CKEditor from 'ckeditor4-react';

const mapState = ({ user, conversationsData }) => ({
	currentUser: user.currentUser,
	conversations: conversationsData.conversations
	
})

const VendorConversationsDetails = props => {
	const { currentUser, conversations } = useSelector(mapState);
	const dispatch = useDispatch();
	const history = useHistory();
	

	const { data2 } = conversations;

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	  useEffect(() => {
		dispatch(
			fetchCustomerConversationsStart()
		);
		// eslint-disable-next-line
	}, []);


	const convoByID = [];
	if(Array.isArray(data2)){
		for(let i = 0; i < data2.length; i++){
			if(data2[i].vendorsID === `${currentUser.id}` && data2[i].userRoles === `customer`){
				convoByID.push(data2[i]);
			}
		}
	}


	const congfigAuthWrapper = {
		headline: 'Vendor Conversations'
	}

	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
		
			<div className="cart">
				<table border="0" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td>
								<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
									<tbody >
									<tr >
										<th className="pr-0">
										Customer Name
										</th>
									
										
										<th className="pl-0 pr-o ml-0">
										Phone
										</th>
										<th>
										Email
										</th>
										<th >
										Service
										</th>
										<th >
										
										</th>
									</tr>
									</tbody>
								</table>
							</td>
						</tr>
						<tr>
							<td>
								<table className="convoResults" border="0" cellPadding="10" cellSpacing="0">
								<tbody>
								
									{(Array.isArray(convoByID) && convoByID.length > 0) && convoByID.map((customer, index) => {
									const {
										serviceName,
										custName,
										custPhone,
										custEmail,
										 custsID
									} = customer;
									
									return (
										<tr key={index}>
										
										<td>
											{custName}
										</td>
										<td>
											<button className="btn" onClick={() => window.open(`tel:${custPhone}`)}>Call</button>
											
										</td>
										<td>
											<button className="btn" onClick={() => window.open(`mailto:${custEmail}`)}>Email</button>
										</td>
										<td className="pl-5">
											{serviceName}
										</td>
										<td className="text-right">
											<button className="btn" onClick={() => history.push(`/vendorConversation/${serviceName}/${custsID}`)}>Chat</button>
										</td>
										
										</tr>
									)
									})}

								</tbody>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

		
		</DashAuthWrapper>

		
	)
}

export default VendorConversationsDetails;